<template>
  <slot v-if="added" />
</template>
<script lang="ts" setup>
import type { AnySourceData, Source, Map, Style } from "mapbox-gl";

const props = defineProps<{
  id: string;
  source: AnySourceData;
}>();

const added = ref(false);

function withoutId<T extends Object>(object?: T & { id?: unknown }): T {
  // @ts-ignore
  return Object.fromEntries(Object.entries(object).filter(([k]) => k != "id"));
}

useMapOn("error", (e) => console.log("MApbox error: ", e));

const mapRef = useMap() as Ref<Map | null>;
function remove(map: Map) {
  if (map.getSource(props.id)) {
    map.removeSource(props.id);
  }
}

watch(
  mapRef,
  (map, oldMap) => {
    if (oldMap) remove(oldMap);
    if (map) {
      remove(map);
      map.addSource(props.id, withoutId<AnySourceData>(props.source));
      added.value = true;
    }
  },
  { immediate: true }
);

watch(
  () => props.source,
  () => {
    const source = mapRef.value?.getSource(props.id);

    if (
      source &&
      "setData" in source &&
      props.source &&
      typeof props.source != "string" &&
      "data" in props.source &&
      props.source.data
    ) {
      source.setData(props.source.data);
    }
  },
  { deep: true }
);

onBeforeUnmount(() => {
  if (mapRef.value) remove(mapRef.value);
});
</script>
